import { FieldDescription } from './user-form.interface';

export const veteranFields: FieldDescription[] = [
  {
    name: 'email',
    type: 'text',
    label: 'Электронная почта',
    placeholder: '',
    required: true,
  },
  {
    name: 'birth_date',
    type: 'custom_datepicker',
    label: 'Дата рождения',
    half_width: true,
    placeholder: 'Выберите дату рождения',
    required: true,
  },
  {
    name: 'citizenship_id',
    type: 'custom_input',
    label: 'Гражданство',
    placeholder: 'Укажите гражданство',
    required: true,
  },
  {
    name: 'category_ids',
    type: 'select_categories',
    label: 'Категория',
    required: true,
  },
  {
    name: 'categories',
    type: 'hidden',
  },
  {
    name: 'phone',
    type: 'text',
    label: 'Номер телефона',
    placeholder: 'Введите ваш номер телефона',
    required: true,
  },
  {
    name: 'family',
    type: 'custom_input',
    label: 'Члены вашей семьи',
  },
  {
    name: 'document_number',
    type: 'text',
    required: true,
    label: 'Серия и номер удостоверения ветерана',
    placeholder: 'Введите серию и номер удостоверения ветерана' },
  {
    name: 'vk',
    type: 'text',
    label: 'Ссылка на профиль ВКонтакте',
    placeholder: 'Вставьте ссылку',
  },
  {
    name: 'ok',
    type: 'text',
    label: 'Ссылка на профиль Одноклассники',
    placeholder: 'Вставьте ссылку',
  },
  {
    name: 'agreement',
    type: 'checkbox',
    label: 'Даю согласие на обработку <a href="/agreement" target="_blank" rel="noopener">персональных данных</a>.',
  },
  {
    name: 'photo_id',
    type: 'hidden',
  },
];



// WEBPACK FOOTER //
// ./src/app/accounts/user-form/veteran.fields.ts